"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pollDownloadUrl = exports.POLL_TIMEOUT = exports.POLL_INTERVAL = void 0;

/**
 * AV-scan poll tuning. Shared by the editor upload flow (which blocks until a
 * fresh upload clears scan) and by the view-side FileAttachmentTile (which
 * probes attachments rendered on a topic/reply page).
 */
var POLL_INTERVAL = 2000;
exports.POLL_INTERVAL = POLL_INTERVAL;
var POLL_TIMEOUT = 300000;
/**
 * Polls the attachment download URL until it's clean (HEAD 200) or the
 * POLL_TIMEOUT budget is exhausted. Resolves `true` on clean, `false` on
 * timeout. Uses HEAD so we don't re-download the file on every probe.
 */

exports.POLL_TIMEOUT = POLL_TIMEOUT;

var pollDownloadUrl = function pollDownloadUrl(downloadUrl) {
  return new Promise(function (resolve) {
    var endTime = Date.now() + POLL_TIMEOUT;

    var poll = function poll() {
      var xhr = new XMLHttpRequest();
      xhr.addEventListener('load', function () {
        if (xhr.status === 200) {
          resolve(true);
        } else if (Date.now() < endTime) {
          setTimeout(poll, POLL_INTERVAL);
        } else {
          resolve(false);
        }
      });
      xhr.addEventListener('error', function () {
        if (Date.now() < endTime) {
          setTimeout(poll, POLL_INTERVAL);
        } else {
          resolve(false);
        }
      });
      xhr.open('HEAD', downloadUrl);
      xhr.send();
    };

    setTimeout(poll, POLL_INTERVAL);
  });
};

exports.pollDownloadUrl = pollDownloadUrl;